import {
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    useIonToast,
    useIonAlert,
    IonButton,
    IonIcon,
} from "@ionic/react";
import { trashOutline } from "ionicons/icons";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { deleteTemplate } from "../../../store/templateDetail/actions/deleteTemplate";
import { findTemplate } from "../../../store/templateDetail/actions/findTemplate";
import { findTemplateQuestions } from "../../../store/templateDetail/actions/findTemplateQuestions";
import { selectTemplateDetail } from "../../../store/templateDetail/selectors/selectTemplateDetail";
import { findTemplatesForUserOrLocation } from "../../../store/templateList/actions/findTemplatesForUserOrLocation";
import { HelperActions } from "./HelperActions";
import { SubmitFileTemplateChangesButton } from "./SubmitFileTemplateChangesButton";

export const Toolbar = () => {
    const dispatch = useDispatch();
    const template = useSelector(selectTemplateDetail);
    const { id }: { id: string } = useParams();

    const [presentToast, hideToast] = useIonToast();
    const [present] = useIonAlert();
    const history = useHistory();

    useEffect(() => {
        dispatch(findTemplate(id));
        dispatch(findTemplateQuestions(id));
    }, [dispatch, id]);

    const handleDeleteTemplate = async () => {
        try {
          presentToast({
            message: `Eliminando plantilla...`,
            color: "primary",
          });
          const {
            payload: { success },
          }: any = await dispatch(deleteTemplate());
          if (!success) {
            throw new Error("No se envió la notificación");
          }
          await hideToast();
          presentToast({
            message: `Se elimino la plantilla.`,
            color: "success",
            duration: 2000,
          });
          await dispatch(findTemplatesForUserOrLocation());
          return history.replace("/app/tic/plantillas-file");
        } catch (error) {
          await hideToast();
          presentToast({
            message: "Ocurrió un problema eliminando la plantilla.",
            color: "danger",
            duration: 2000,
          });
        }
      };

    return (
        <IonToolbar>
            <IonButtons slot="start">
                <IonBackButton
                    text=""
                    defaultHref="/app/tic/plantillas-file"
                    color="light"
                />
            </IonButtons>
            <IonTitle className="ion-hide-md-down">{template.name}</IonTitle>
            <IonButtons className="ion-hide-md-up" slot="end">
                <HelperActions />
                <SubmitFileTemplateChangesButton />
            </IonButtons>
            <IonButtons className="ion-hide-md-down" slot="end">
            <IonButton
          fill="solid"
          color="danger"
          onClick={() => {
            present({
              header: `¿Deseas eliminar esta plantilla?`,
              buttons: [
                "No",
                {
                  text: "Eliminar plantilla",
                  handler: () => handleDeleteTemplate(),
                },
              ],
            });
          }}
        >
          <IonIcon icon={trashOutline}/>
        </IonButton>
            </IonButtons>
        </IonToolbar>
    );
};
